import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography } from "../../ppui";
import {
  ContentHeading,
  ContentLayout,
  ContentWrapper,
  ContentMenu,
  ContentForm,
} from "../style";
import { Outlet } from "react-router-dom";
import { List, ListIcon, ListItem, ListText } from "../../ppui/list";
import { TbCalendarExclamation, TbDevicesDollar, TbPasswordUser, TbUserScan, TbWorldPin } from "react-icons/tb";

function OrganizationalSetup() {
  const navigate = useNavigate();
  const location = useLocation();
  const menuItems = [
    {
      icon: <TbDevicesDollar />,
      primaryText: "Banking And Finance",
      path: "/setup",
    },
    {
      icon: <TbWorldPin />,
      primaryText: "Branch Information",
      path: "/setup/branch",
    },
    {
      icon: <TbPasswordUser />,
      primaryText: "Department",
      path: "/setup/department",
    },
    {
      icon: <TbUserScan />,
      primaryText: "Designation",
      path: "/setup/designation",
    },
    {
      icon: <TbCalendarExclamation />,
      primaryText: "Holiday Setup",
      path: "/setup/holiday",
    },
  ];

  return (
    <>
      <ContentLayout>
        <ContentHeading>
          <Typography variant="h5" mb="0">
            Organizational Setup
          </Typography>
        </ContentHeading>

        <ContentWrapper>
          <ContentMenu>
            <List
              size={"md"}
              color={"default"}
              activeColor={"default"}
              Colorvariant={"dark"}
              hover={"secondary"}
              gap={15}
            >
              {menuItems.map((item, index) => (
                <ListItem
                  key={index}
                  onClick={() => navigate(item.path)}
                  className={location.pathname === item.path ? "active" : ""}
                  isActive={location.pathname === item.path}
                  colorVariant="light"
                >
                  <ListIcon>{item.icon}</ListIcon>
                  <ListText primary={item.primaryText} />
                </ListItem>
              ))}
            </List>
          </ContentMenu>
          <ContentForm>
            <Outlet />
          </ContentForm>
        </ContentWrapper>
      </ContentLayout>
    </>
  );
}

export default OrganizationalSetup;
